import { project } from './initializeStats.js';
import { statsArticle } from './statsArticle.js';
import { inViewport } from './elementsInViewport.js';
import { linkStats, setStatElementCollector, shareStats } from './stats.js';
import { wideo } from './wideo.js';
import { menu, menuMap } from './menu.js';
import { anchors } from './anchors.js';
import { accordion } from './widgets/accordeon.js';
import { beforeAfter } from './widgets/beforeAfter.js';
import { galleryHover } from './widgets/galleryHover.js';
import { sliderSwiperWindow, sliderSwiperWide, sliderSwiperMap } from './widgets/slider.js';
import { audioPlay } from './widgets/audio.js';
import { hotpoints } from './widgets/hotpoints.js';
import { recipeVoting } from './recipeVoting.js';
import { loadMore } from './load_more.js';

import { formAddRecipe } from './formAddRecipe.js';

formAddRecipe('dodajPrzepis'); //id formularza
formAddRecipe('Konkurs'); //id formularza

anchors();
statsArticle();
setStatElementCollector();
linkStats();
inViewport();
shareStats();
//addRecipe();
document.querySelectorAll('.player').forEach((el) => {
	
	wideo(el);
	
	//przełącznik wideo na jednej instancji, dodatkowo ze zmianą opisów
	if (el.classList.contains('__jsPlayerSG') && el.closest('.wideo__outer')) {

		const descList = el.closest('.wideo__outer').querySelectorAll('.wideo__desc li');
		document.querySelectorAll('.wideo__next_item').forEach((item, index) => {

			const url = 'https://wideo.wp.pl/player/embed.json?mid=' + /mid=([0-9]+)/.exec(item.dataset.url)[1] + '/secured';
			fetch(url)
				.then(response => {
					if (!response.ok) {
						item.querySelector('img').src = 'http://kulinarna-stolica-polski.wpcdn.pl/i/player-poster-domain.jpg';
						throw new Error('Nie zaczytuje się response');												
					}
					return response.json();
				})
				.then(data => {
					let imgSrc = new URL(data.clip.screenshot);
						imgSrc = 'https://i.wpimg.pl/190x108/' + imgSrc.hostname + imgSrc.pathname;

					item.querySelector('img').src = imgSrc;


					
				});
			
			item.addEventListener("click", e => {

				descList.forEach((li, i) => {
					if (i==index) {
						li.classList.add('__jsActive');
					} else {
						li.classList.remove('__jsActive');
					}
				});
				

				


				let instance = WP.player.list.find(x => x.id === el.firstChild.id);
				if (instance) {
						instance.setUrl(item.dataset.url);
						setTimeout(()=>{
							if (!instance.isPlaying())
								instance.setUrl(item.dataset.url);
							
						}, 250);
				}
			});	
		});
	}
});

menu('.header__nav', '.header__nav_triger');
menu('.header__woj_nav', '.header__woj_triger');
menuMap('.map__areas', '.map__areas_more');

const currentWojPath = window.location.pathname.replace(/\/$/, '');
document.querySelectorAll('.header__woj_nav a').forEach((a) => {
	if (a.getAttribute('href') === currentWojPath) {
		a.closest('li').classList.add('__jsActive');
	}
});

loadMore('.__jsMoreTarget');

accordion();
beforeAfter();
galleryHover();
sliderSwiperWindow();
sliderSwiperWide();
sliderSwiperMap();
audioPlay();
hotpoints();


window.addEventListener('pagehide', project.unloadData.bind(project));


/* etykieta liczby wydarzen – wspolna dla mapy Polski i widoku wojewodztwa */
function eventCountLabel(n) {
	if (n === 1) return '1 wydarzenie';
	if (n >= 2 && n <= 4) return n + ' wydarzenia';
	return n + ' wydarzeń';
}

/* map hovers */

const mapLevel0 = document.getElementById('mapLevel-0');
if (mapLevel0) {
	const regionList = mapLevel0.querySelectorAll('.map__area .map_range');
	const regionDescList = document.querySelectorAll('.map__desc');
	// console.log(regionList);
	// console.log(regionDescList);
	const activateRegion = (region) => {
		const regionTarget = region.dataset.for;

		if (!regionDescList[regionTarget]) return;
		if (region.classList.contains('__jsActive')) return;

		regionDescList.forEach(regionDesc => {
			regionDesc.classList.remove('__jsVisible');
		})
		regionList.forEach(reg => {
			reg.classList.remove('__jsActive');
		})

		regionDescList[regionTarget].classList.add('__jsVisible');
		regionList[regionTarget - 1].classList.add('__jsActive');
	};

	// link "więcej o regionie" z opisu przypisanego do województwa
	const regionHref = (region) => {
		const desc = regionDescList[region.dataset.for];
		const link = desc && desc.querySelector('a[href]');
		const href = link && link.getAttribute('href');
		return href && href !== '#' ? href : null;
	};

	regionList.forEach(region => {
		region.addEventListener('mouseenter', () => activateRegion(region));
		// klik wchodzi na stronę regionu – przy przełączaniu opisu hoverem nie da się
		// dojechać kursorem do przycisku w opisie bez zmiany aktywnego województwa
		region.addEventListener('click', () => {
			activateRegion(region);
			const href = regionHref(region);
			if (href) window.location.href = href;
		});
	});
}


/* map pins */
const mapLevel1 = document.getElementById('mapLevel-1');
if (mapLevel1) {
	const pinsMap = mapLevel1.querySelector('.map__pins');
	const pinsList = pinsMap.querySelectorAll('.map__pin');
	const pinsEventList = mapLevel1.querySelectorAll('.map__area_item');

	pinsList.forEach(pin => {
		pin.style.left = pin.dataset.left + '%';
		pin.style.top = pin.dataset.top + '%';

		// data-for może być listą: "1" lub "1,2,3" (cluster)
		const targets = pin.dataset.for.split(',').map(s => s.trim());
		const count = targets.length;

		const tooltip = document.createElement('div');
		tooltip.className = 'map__pin_tooltip';
		tooltip.textContent = eventCountLabel(count);
		pin.appendChild(tooltip);

		pin.addEventListener('click', () => {
			selectPin(pin, targets);
		});
	});

	function selectPin(pin, targets) {
		pinsList.forEach(p => p.classList.remove('__jsActive'));
		pin.classList.add('__jsActive');

		mobileChips.forEach(c => c.classList.remove('__jsActive'));
		const chip = mobileChipsByPin.get(pin);
		if (chip) chip.classList.add('__jsActive');

		pinsEventList.forEach(item => item.classList.remove('__jsActive'));

		// pokazuje tylko pierwsze (najwcześniejsze) wydarzenie z clustra
		const firstItem = mapLevel1.querySelector(`.map__area_item[data-pin-id="${targets[0]}"]`);
		if (firstItem) firstItem.classList.add('__jsActive');
	}

	/* mobile - chipy z miastami, dane z pinów (jedno źródło prawdy z CMS) */
	const mobileList = mapLevel1.querySelector('.map__city_select');
	const mobileChipsByPin = new Map();
	const mobileChips = [];

	if (mobileList) {
		pinsList.forEach(pin => {
			const targets = pin.dataset.for.split(',').map(s => s.trim());
			const cityName = pin.querySelector('span').textContent;

			const li = document.createElement('li');
			const button = document.createElement('button');
			button.type = 'button';
			button.textContent = cityName;
			li.appendChild(button);
			mobileList.appendChild(li);

			mobileChipsByPin.set(pin, button);
			mobileChips.push(button);

			button.addEventListener('click', () => {
				selectPin(pin, targets);
			});
		});
	}
}


recipeVoting('.promo_voting');